import React from "react";
import {
  Heading,
  InputGroup,
  InputLeftElement,
  Input,
  Checkbox,
  Stack,
  Text,
} from "@chakra-ui/react";

class FreeReportRequest extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      reportTitle: props.reportTitle || "",
    };
  }

  getValue = () => {
    return {
      type: "free-report-request",
      props: this.state,
    };
  };

  validate = () => !!this.state.reportTitle;

  render = () => {
    return (
      <div>
        <Heading size="lg" mb={5} data-cy="free-report-request-component">
          Free Report Request
        </Heading>
        <Stack mb={8} data-cy="form-field-inputs">
          <Text mb={0} fontWeight={"bold"}>
            Form Fields
          </Text>
          <InputGroup>
            <InputLeftElement pointerEvents="none">
              <Checkbox mt={2} isDisabled defaultChecked />
            </InputLeftElement>
            <Input
              disabled
              type="text"
              placeholder="First Name"
              data-cy="form-field-input"
            />
          </InputGroup>
          <InputGroup>
            <InputLeftElement pointerEvents="none">
              <Checkbox mt={2} isDisabled defaultChecked />
            </InputLeftElement>
            <Input
              disabled
              type="text"
              placeholder="Last Name"
              data-cy="form-field-input"
            />
          </InputGroup>
          <InputGroup>
            <InputLeftElement pointerEvents="none">
              <Checkbox mt={2} isDisabled defaultChecked />
            </InputLeftElement>
            <Input
              disabled
              type="email"
              placeholder="Email"
              data-cy="form-field-input"
            />
          </InputGroup>
          <InputGroup>
            <InputLeftElement pointerEvents="none">
              <Checkbox mt={2} isDisabled defaultChecked />
            </InputLeftElement>
            <Input
              type="industry"
              defaultValue={this.state.reportTitle}
              placeholder="Report Title (Required)"
              data-cy="form-field-input"
              onChange={(e) => {
                this.setState({
                  reportTitle: e.target.value,
                });
              }}
            />
          </InputGroup>
        </Stack>
      </div>
    );
  };
}

export default FreeReportRequest;
